export enum DesignPlatform {
    threeShape = 1,
    sprintRayCadApp = 2,
}
